<template>
  <div class="swz_container">
    <div class="title">{{ data.name || '' }}</div>
    <div class="content">
      <div class="left">
        <div class="s-title">污染类型占比</div>
        <Pie ref="proportion" />
      </div>
      <div class="right">
        <div class="tabs">
          <div class="s-title s-title2" :class="{ 's-title-ac': tabAc === '水文' }" @click="setTab('水文')">水文监测数据</div>
          <div class="s-title s-title2 ml10" :class="{ 's-title-ac': tabAc === '水质' }" @click="setTab('水质')">水质监测数据
          </div>
        </div>

        <div v-show="tabAc === '水文'" class="factor_container">
          <div class="options">
            <div v-for="(item, index) in factorOptions" :key="index" class="factor"
              :class="{ active: currentCode === item.factorCode }" @click="handleData(item)">
              {{ item.factorName }}
            </div>
          </div>

          <div class="right-box">
            <n-date-picker v-model:value="time" size="small" type="date" :on-update:value="onTimeChange"
              format="yyyy-MM-dd" />
          </div>
        </div>
        <subBasinLine v-show="tabAc === '水文'" ref="subBasinLine" class="charts_container" />

        <div v-show="tabAc === '水质'" class="factor_container">
          <div class="options">
            <div v-for="(item, index) in factorOptions2" :key="index" class="factor"
              :class="{ active: currentCode2 === item.factorCode }" @click="handleData2(item)">
              {{ item.factorName }}
            </div>
          </div>

          <div class="right-box">
            <n-date-picker v-model:value="time2" size="small" type="date" :on-update:value="onTimeChange2"
              format="yyyy-MM-dd" />
          </div>
        </div>
        <subBasinLine2 v-show="tabAc === '水质'" ref="subBasinLine2" class="charts_container2" />
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from '@/api/publicApi';
import subBasinLine from '@/components/charts/subBasinLine.vue';
import subBasinLine2 from '@/components/charts/subBasinLine2.vue';
import Pie from '@/components/charts/SwzPieChart.vue'
import { factors } from '@turf/turf';
const api = new Api();
import moment from 'moment';

export default {
  props: ['data'],
  components: {
    subBasinLine,
    subBasinLine2,
    Pie
  },
  data() {
    return {
      factorOptions: [],
      factorOptions2: [
        { factorName: '高锰酸盐指数', factorCode: 0 },
        { factorName: '氨氮', factorCode: 1 },
        { factorName: '总磷', factorCode: 2 },
        { factorName: '总氮', factorCode: 3 },
        { factorName: '化学需氧量', factorCode: 4 },
        { factorName: '磷酸盐', factorCode: 5 },
        { factorName: '硝酸盐氮', factorCode: 6 },
      ],
      currentCode: '',
      currentCode2: '',
      unit: '',
      factorName: '',
      factorName2: '',
      tabs: ['水文', '水质'],
      tabAc: '水文',
      pieData: [
        {
          "name": "呼家嘴河入圣水河",
          "code": "25030821",
          "dateTime": "2022/7/20",
          "畜禽粪污": "90.32",
          "工业废水": "0.14",
          "农业种植": "0.02",
          "城市生活污水": "0.4",
          "农村生活污水": "0",
          "水产养殖": "7.4",
          "水生植物": "1.6"
        },
        {
          "name": "天堂河入圣水河",
          "code": "25030819",
          "dateTime": "2022/7/20",
          "畜禽粪污": "18.79",
          "工业废水": "1.04",
          "农业种植": "56.1",
          "城市生活污水": "1.26",
          "农村生活污水": "1.4",
          "水产养殖": "2.82",
          "水生植物": "18.59"
        },
        {
          "name": "王家河入圣水河",
          "code": "25030820",
          "dateTime": "2022/7/20",
          "畜禽粪污": "19.9",
          "工业废水": "21.7",
          "农业种植": "3.03",
          "城市生活污水": "35.06",
          "农村生活污水": "1.2",
          "水产养殖": "16.07",
          "水生植物": "3.05"
        },
        {
          "name": "猫溪桥",
          "code": "25030822",
          "dateTime": "2022/7/20",
          "畜禽粪污": "3.72",
          "工业废水": "31.54",
          "农业种植": "10.70",
          "城市生活污水": "41",
          "农村生活污水": "1.15",
          "水产养殖": "10.86",
          "水生植物": "1.04"
        },
        {
          "name": "茨坝",
          "code": "T10000_0034",
          "dateTime": "2022/7/20",
          "畜禽粪污": "13.71",
          "工业废水": "20.27",
          "农业种植": "0.72",
          "城市生活污水": "55.94",
          "农村生活污水": "0",
          "水产养殖": "7.85",
          "水生植物": "1.5"
        }
      ],
      pieTypeList: ['畜禽粪污', '工业废水', '农业种植', '城市生活污水', '农村生活污水', '水产养殖', '水生植物'],
      pieChartData: [
        {
          value: 629,
          name: '禽畜养殖',
          nubmber: 25,
          change: '2↓',
          proportion: '100%',
        }
      ],
      time: new Date().getTime(),
      time2: new Date('2025-09-22').getTime(),
      beginTime: '',
      endTime: '',
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    setTab(val) {
      this.tabAc = val;
      val === '水文' ? this.initData() : this.initData2();
    },
    initData() {
      this.pieChartData = [];
      api.screen.stationDetailGet({ mn: this.data.id }).then(res => {
        if (res.code == 200) {
          this.pieData.forEach(item => {
            if (item.code == this.data.id) {
              Object.keys(item).forEach(k => {
                console.log('item.k=====>', k);
                if (this.pieTypeList.includes(k)) {
                  this.pieChartData.push({
                    name: k,
                    value: item[k],
                    proportion: '100%',
                  })
                }
              })
            }
          })
          this.$nextTick(() => {
            this.$refs.proportion.initChart(this.pieChartData);
          })
          if (res.data) {
            const data = res.data;
            let deviceId = '';
            if (data.devices && data.devices.length) {
              deviceId = data.devices[0].deviceId;
            }
            if (data.lastData && data.lastData.data) {
              this.time = new Date(data.lastData.data.data_time).getTime();
            }
            if (data.factorMap) {
              this.factorOptions = data.factorMap[deviceId];
              this.handleData(this.factorOptions[0]);
            }
          }
        }
      })
    },
    initData2() {
      this.currentCode2 = 0;
      this.factorName2 = '高锰酸盐指数';
      this.setLine2();
    },
    handleData(val) {
      this.currentCode = val.factorCode;
      this.unit = val.unit;
      this.factorName = val.factorName;
      this.setLine();
    },
    handleData2(val) {
      this.currentCode2 = val.factorCode;
      this.factorName2 = val.factorName;
      this.setLine2();
    },
    onTimeChange(val) {
      this.time = val;
      this.setLine();
    },
    onTimeChange2(val) {
      this.time2 = val;
      this.setLine2();
    },
    async setLine() {
      let data = [];
      if (!this.time) return;
      await api.screen
        .getMonitorDataListUsingGet({
          begin: this.format(this.time),
          factor: this.currentCode,
          frequency: 'H',
          mn: this.data.id,
        })
        .then((res) => {
          if (res.code == 200) {
            data = res.data
          }
        })
      const XData = [];
      const YData = [];
      for (let i = 0; i < data.length; i += 1) {
        XData.push(data[i].dataTime)
        YData.push(data[i].value)
      }
      this.$nextTick(() => {
        this.$refs.subBasinLine.initChart(XData, YData, this.factorName, '#ff9700', this.unit);
      })
    },
    setLine2() {
      let data = [];
      if (!this.time2) return;
      const params = {
        beginTime: moment(this.time2).format('YYYY-MM-DD 00:00:00'),
        endTime: moment(this.time2).format('YYYY-MM-DD 23:59:59'),
        factorName: this.factorName2,
        mn: this.data.id
      }
      api.screen.arealSourceByMnGet(params).then(res => {
        if (res.code == 200) {
          data = res.data.lineDatas;
          const XData = [];
          const YData = [];
          const YData2 = [];
          for (let i = 0; i < data.length; i += 1) {
            XData.push(data[i].dataTime);
            YData.push(data[i].ndz);
            YData2.push(data[i].xstl);
          }
          this.$nextTick(() => {
            this.$refs.subBasinLine2.initChart(XData, YData, YData2);
          })
        }
      })
    },
    format(val) {
      const time = new Date(val);
      const y = time.getFullYear();
      const m = time.getMonth() + 1;
      const d = time.getDate();
      return y + '-' + this.add0(m) + '-' + this.add0(d);
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    }
  },
}

</script>

<style>
.swz_container {
  width: 1150px;

  .title {
    font-size: 2.4rem;
    font-weight: bold;
    height: 6rem;
    line-height: 3.15rem;
    text-align: left;
  }

  .content {
    display: flex;

    .tabs {
      display: flex;
    }

    .s-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
      height: 30px;
      width: 120px;
      text-align: center;
      line-height: 30px;
    }

    .s-title2 {
      cursor: pointer;
    }

    .s-title-ac {
      background-color: #ffffff;
      color: #0088bf;
    }

    .left {
      width: 450px;
    }

    .right {
      width: 700px;
    }
  }

  .info_content {
    /* height: 3rem; */
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    .info_item {
      flex: 1;
      display: flex;

      .item_category {
        margin-right: 2rem;
      }
    }
  }

  .factor_container {
    height: 4rem;
    overflow: hidden;
    align-items: center;
    line-height: 28px;
    display: flex;

    .options {
      width: 600px;
      display: flex;
    }

    .factor {
      /* display: inline-block; */
      /* min-width: 4rem; */
      padding: 0.2rem 0.5rem;
      text-align: center;
      cursor: pointer;

      &.active {
        background-color: #ffffff;
        color: #0088bf;
      }
    }

    .right-box {
      /* float: right; */
      vertical-align: top;
      display: flex;

      .condition {
        display: flex;

        .echart-btn {
          padding: 0 0.6rem;
          height: 2.65rem;
          line-height: 2.65rem;
          background-color: transparent;
          border: 0.025rem solid #fff;
          color: #fff;
          cursor: pointer;

          &:last-of-type {
            margin-right: 1rem;
          }

          &.active {
            background-color: #ffffff;
            color: #0088bf;
          }
        }
      }

      .font {
        margin: 0 5px;
      }
    }

    :deep(.n-date-picker) {
      float: right;
      width: 120px;
    }
  }

  .condition {
    .benchmark {
      display: flex;
      justify-content: flex-end;

      span {
        line-height: 26px;
      }

      ::v-deep .n-select {
        width: 110px;
        height: 26px;

        .n-base-selection-label,
        .n-base-selection__state-border,
        .n-base-selection__border {
          height: 26px;
          line-height: 26px;
        }
      }
    }
  }

  .charts_container {
    width: 700px;
    height: 260px;
  }

  .charts_container2 {
    width: 700px;
    height: 260px;
  }

  .ml10 {
    margin-left: 10px;
  }
}
</style>